import { render, staticRenderFns } from "./neweditor.vue?vue&type=template&id=1b9999c4&"
import script from "./neweditor.vue?vue&type=script&lang=js&"
export * from "./neweditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports